import Delta from 'quill-delta';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { EvaluationSubmissionDocument } from '@treams/treams-network';
import { Modal, Popover, QuillInput } from '@treams/treams-ui';

export default function EvaluationNoteEditorModal(props: {
	comment: graphql.CommentFragment;
	submissionID: string;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [value, setValue] = useState<Delta>(props.comment.content ?? new Delta());
	const [loading, setLoading] = useState(false);

	const [update] = graphql.useCommentMutation();

	const onSave = async () => {
		if (loading) {
			return;
		}

		setLoading(true);

		await update({
			variables: {
				input: {
					id: props.comment.id,
					content: value,
				},
			},
			refetchQueries: [EvaluationSubmissionDocument, props.submissionID],
			onCompleted: () => {
				props.onDismiss();
			},
		});
	};

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header title={t('evaluation.submission.notes.title')} onClose={props.onDismiss} />
				<Modal.Contents>
					<QuillInput value={value} onChange={setValue} />
				</Modal.Contents>

				<Modal.FormFooter onSave={onSave} saveTitle={t('common.save')} />
			</Modal>
		</Popover>
	);
}
